module.exports = __webpack_public_path__ + "static/img/scrollImg2.89d33b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scrollImg2.png
// module id = neHY
// module chunks = 2